import { AnyAction, Reducer, combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';

import config from '../../config';
import crossSellReducer from './model/crossSell.slice';
import customerReducer from './model/customer.slice';
import examReducer from './model/exam.slice';
import offerReducer from './model/offer.slice';
import formReducer from './state/form.slice';
import messageReducer from './state/message.slice';
import modalReducer from './state/modal.slice';
import progressBarReducer from './state/progressBar.slice';
import flowReducer from './state/flow.slice';
import loadingReducer from './state/loading.slice';
import overflowReducer from './state/overflow.slice';
import personalVoucherReducer from './state/personalVoucher.slice';
// === List of all redducers (state + model are persisted; ui is not)
const combinedReducer = combineReducers({
  state: combineReducers({
    progressBar: progressBarReducer,
    form: formReducer,
    modal: modalReducer,
    message: messageReducer,
    flow: flowReducer,
    overflow: overflowReducer,
    personalVoucher: personalVoucherReducer,
  }),
  model: combineReducers({
    customer: customerReducer,
    exam: examReducer,
    offer: offerReducer,
    crossSell: crossSellReducer,
  }),
  ui: loadingReducer,
});

const rootReducer: Reducer = (state: RootState, action: AnyAction): RootState => combinedReducer(state, action);

// export const AppReducers = (state: any, action: any): RootState => {
//   return AllReducers(state, action);
// };

// === LocalSotrage persist definition
const persistConfig = {
  key: 'dzo',
  storage: storageSession,
  whitelist: ['model', 'state'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// const initialState = {};

// const middleware = [thunk];

export const store = configureStore(
  {
    reducer: persistedReducer,
    devTools: config.REACT_APP_IS_DEV === 'true',
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false
      }),
  }
  // persistedReducer,
  // initialState,
  // composeWithDevTools(applyMiddleware(...middleware))
  // compose(applyMiddleware(...middleware))
);

export type RootState = ReturnType<typeof combinedReducer>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);

// export type RootState = ReturnType<typeof AllReducers>;

// Q: how to clear redux state on logout? 
// A: https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store  
// Q: it is too old solution, for older version of redux, how to do it with redux-toolkit?
// A: https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store
